import { useQuery } from '@apollo/client';
import { createError } from '@common/neo.tax';

import {
  GET_RD_PROJECT_GROUPING_TICKETS_OR_COLLECTIONS,
  GetRdProjectGroupingTicketsOrCollectionsQuery,
  GetRdProjectGroupingTicketsOrCollectionsQueryVariables,
} from '@neo.tax/shared';

export type RdGroupingTicketOrCollection =
  GetRdProjectGroupingTicketsOrCollectionsQuery['getRdProjectGroupingTicketsOrCollections'][number];

type UseRdProjectGroupingTicketsOrCollectionsResult =
  | {
      data: GetRdProjectGroupingTicketsOrCollectionsQuery['getRdProjectGroupingTicketsOrCollections'];
      loading: false;
    }
  | {
      loading: true;
      data: null;
    };

export const useRdProjectGroupingTicketsOrCollections = ({
  fiscalYearId,
  rdProjectId,
  searchKeyword,
}: {
  rdProjectId: string;
  fiscalYearId: string;
  searchKeyword?: string | null;
}): UseRdProjectGroupingTicketsOrCollectionsResult => {
  const { data, error, loading } = useQuery<
    GetRdProjectGroupingTicketsOrCollectionsQuery,
    GetRdProjectGroupingTicketsOrCollectionsQueryVariables
  >(GET_RD_PROJECT_GROUPING_TICKETS_OR_COLLECTIONS, {
    variables: { rdProjectId, fiscalYearId, searchKeyword: searchKeyword || undefined },
  });

  if (loading) {
    return { loading: true, data: null };
  }

  if (error) {
    throw error;
  }

  if (!data) {
    throw createError('MissingDataError', `useRdProjectGroupingTicketsOrCollections ${rdProjectId}`);
  }

  return { loading: false, data: data?.getRdProjectGroupingTicketsOrCollections };
};
